/* eslint-disable no-comments/disallowComments */

import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AnalyticsDataLayer } from './../../../../services/analytics/definitions/analytics.interface';
import { AnalyticsService } from './../../../../services/analytics/analytics.service';
import { ApiResponse } from '../../../../definitions/api-response.interface';
import { ConfirmRegistrationFactory } from './confirm-registration.factory';
import { ConfirmPageLabels, ConfirmPageSections, ConfirmRegistrationState } from './definitions';
import { EnvironmentRef } from '../../../../../environments/interfaces';
import { expEnvironmentRef } from '../../../../injection-tokens/environment.injection-token';
import { AemApiService } from '../../../../services/api/api.aem.service';
import { ApplicationPath, IsRequestSubmittedForReview } from '../../../../services/shared/shared-enums';
import { SharedService } from '../../../../services/shared/shared.service';
import { has as lodashHas, set as lodashSet, noop as lodashNoop, get as lodashGet } from 'lodash';
import { KngFooterState } from 'kinetic-angular';

@Injectable({
	providedIn: 'root'
})
export class ConfirmRegistrationService
{
	private readonly state$: BehaviorSubject<ConfirmRegistrationState> = new BehaviorSubject<ConfirmRegistrationState>(
		ConfirmRegistrationFactory.build()
	);
	get state(): ConfirmRegistrationState
	{
		return this.state$.value;
	}
	get stateChanged(): Observable<ConfirmRegistrationState>
	{
		return this.state$.asObservable();
	}
	get isRaymond():boolean | undefined
	{
		return this.environmentRef.isRaymond;
	}
	constructor(
		public aemApiService: AemApiService,
		private readonly router: Router,
		private readonly sharedService: SharedService,
    private readonly analyticsService: AnalyticsService,

    @Inject(expEnvironmentRef) private readonly environmentRef: EnvironmentRef
	){}

	public updateState(value: ConfirmRegistrationState): void
	{
		this.state$.next(value);
	}

	public navigateForUserRegistrationStatus(): void
	{
		this.sharedService.navigateMethod(this.router, ApplicationPath.authentication);
	}
	public getFooterData():void
	{
		this.aemApiService.getFooterData().subscribe((res:ApiResponse)=>
		{
			if(this.isRaymond) 
			{
				this.state.footer= <KngFooterState>res.data;
				this.state.footer.ribbonImage='/assets/images/raymondFooterRibbon.png';
			}  
			else 
			{
				const data = res.data as { unifiedFooter: string; css: { ecomm: string }; script: {} };
				this.state.footer.footercontent.unifiedFooter = data.unifiedFooter;
				this.state.footer.footercontent.css.ecomm = data.css?.ecomm;
				this.state.footer.footercontent.script = data.script;
				this.aemApiService.loadFooterScripts(this.state.footer.footercontent.script);
				this.aemApiService.loadFooterStyles(this.state.footer.footercontent.css.ecomm);
			}
			this.updateState(this.state);
		});
	}
	public trackAnalyticsEvent(data: AnalyticsDataLayer)
	{
		const values = Object.values(localStorage);
		for (const value of values)
		{
			if (value.includes('idTokenClaims'))
			{
				const parsedVal = JSON.parse(value);
				!lodashHas(parsedVal, 'idTokenClaims.emails') ? lodashSet(parsedVal, 'idTokenClaims.emails', [lodashGet(parsedVal, 'idTokenClaims.email', '')]) : lodashNoop();
				this.analyticsService.trackRegistrationByEvent(data,  parsedVal.idTokenClaims.emails[0]);
			}
		}
	}
	public getPageLabels()
	{
		this.aemApiService.getPendingApprovalLabels().subscribe((response: ApiResponse) =>
		{
			const responseObj: ConfirmPageSections = <ConfirmPageSections> response.data;
			this.state.pageLabels = responseObj;
			const isRegistrationSubmittedForReview = localStorage.getItem(IsRequestSubmittedForReview.isRequestSubmittedForReview);
			if(isRegistrationSubmittedForReview) this.updatePageLabels(this.state.pageLabels.submittedRegistrationForReview);
			else this.router.url === ApplicationPath.pendingBusinessApproval? this.updatePageLabels(this.state.pageLabels.pendingBusinessAccountApproval) : this.updatePageLabels(this.state.pageLabels.pendingApproval);
		});
	}
	public getPageLabelsRaymond()
	{
		this.aemApiService.getPendingApprovalLabelsRaymond().subscribe((response: ApiResponse) =>
		{
			const responseObj: ConfirmPageSections = <ConfirmPageSections> response.data;
			this.state.pageLabels = responseObj;
			const isRegistrationSubmittedForReview = localStorage.getItem(IsRequestSubmittedForReview.isRequestSubmittedForReview);
			if(isRegistrationSubmittedForReview) 
			{
				this.updatePageLabels(this.state.pageLabels.submittedRegistrationForReview);
			}
			else 
			{
				this.router.url === ApplicationPath.pendingBusinessApproval ? this.updatePageLabels(this.state.pageLabels.pendingBusinessAccountApproval) : this.updatePageLabels(this.state.pageLabels.pendingApproval);
			}
		});
	}
	updatePageLabels(labels: ConfirmPageLabels)
	{
		this.state.pageHeading = labels.mainText;
		this.state.pageDescription = this.sharedService.customerServiceMail(labels.subText);
		this.state.refreshPageButton.label = labels.refreshButton.label;
		this.state.logo.altText = labels.logo.altText;
	}
}
